import { useEffect, useState } from "react";
import nextCookie from "next-cookies";
import Head from "next/head";
import { Router } from "next/router";
import ClipLoader from "react-spinners/ClipLoader";
import * as fbq from '../../lib/fpixel'

import { productsApi } from "../../services/api";
import {Loading} from "../../styles/busca";
import SidebarPage from "../../components/SidebarPage";
import ProductPage from "../../components/ProductPage";

const Produto = ({ fetchedProduct, token, outlet }) => {

  const [loading, setLoading] = React.useState(false);
  
  async function loadScreen(isLoading){
    setLoading(isLoading);
    setTimeout(() => {
      setLoading(false)
    }, 5000)
}
  const [relateds, setRelateds] = useState([]);
  useEffect(() => {
    if (!!fetchedProduct.error){
      // if (typeof window !== "undefined") {
      //   location.replace("/"); 
      // }
    }else{
      async function fetchRelateds() {
        const fetchedRelateds = await productsApi.relateds(fetchedProduct.sku, {
          user_token: token,
          outlet
        });

        setRelateds(fetchedRelateds);
      }
      fetchRelateds();
    };
  }, []);

  return (
    <>
               {loading ?
              <Loading>
                <ClipLoader color={'#F37A24'} loading={loading} size={80} />
              </Loading>
              :
              ""
              } 

    <SidebarPage token={token} loadScreen={loadScreen}>
      <Head>
        <title key="title">{fetchedProduct.name} | Goods Br</title>
        <meta
          key="og-title"
          property="og:title"
          content={`${fetchedProduct.name} | Goods Br`}
        />
        {fetchedProduct.description && (
          <meta
            property="og:description"
            content={fetchedProduct.description}
            key="description"
          />
        )}
        {(!fetchedProduct.error && fetchedProduct.images[0]) && (
          <meta
            key="og-image"
            property="og:image"
            content={fetchedProduct.images[0]}
          />
        )}
      </Head>
      { !fetchedProduct.error && (<ProductPage product={fetchedProduct} relateds={relateds} token={token} />)}
    </SidebarPage>
    </>
  );
};

Produto.getInitialProps = async ctx => {
  const { token,outlet_cookie, nacional_cookie, noImage_cookie, internacional_cookie, lancamento_cookie, lancamentoLT_cookie, saldos_cookie, outlet } = nextCookie(ctx);

    const fetchedProduct = await productsApi.get(ctx.query.slug, {
      user_token: token,
      outlet_cookie,
      nacional_cookie,
      noImage_cookie,
      internacional_cookie,
      lancamento_cookie,
      lancamentoLT_cookie,
      saldos_cookie
    });

    return {
      fetchedProduct,
      outlet_cookie,
      nacional_cookie,
      noImage_cookie,
      internacional_cookie,
      lancamento_cookie,
      lancamentoLT_cookie,
      saldos_cookie,
      token,
      outlet
    };

};

export default Produto;
